module.exports = require('./helpers/bundle-url').getBundleURL('cU4yt') + "logo.c51670a8.svg";